import { render, staticRenderFns } from "./LpuAdvantages.vue?vue&type=template&id=2db3110b&scoped=true&"
import script from "./LpuAdvantages.vue?vue&type=script&setup=true&lang=ts&"
export * from "./LpuAdvantages.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./LpuAdvantages.vue?vue&type=style&index=0&id=2db3110b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db3110b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2db3110b')) {
      api.createRecord('2db3110b', component.options)
    } else {
      api.reload('2db3110b', component.options)
    }
    module.hot.accept("./LpuAdvantages.vue?vue&type=template&id=2db3110b&scoped=true&", function () {
      api.rerender('2db3110b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuAdvantages/LpuAdvantages.vue"
export default component.exports